/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { FiCalendar, FiAnchor } from 'react-icons/fi';
import AppButton from '../../../../shared/components/app-button/AppButton';
import placeholder from '../../assets/cruise-placeholder.jpg';
import {
  cruiseTitle,
  fareTypeLabel,
  fareTypeSub,
  formatAmount,
  formatDateRange,
  isRoundTrip,
  nightsOf,
  perAdultTotal,
  portLabel,
  titleCase,
  wholePartyTotal,
} from '../../utils/cruiseUtils';

function CruiseCard({ cruise, fare, onFareChange, onSelect }) {
  const options = Array.isArray(cruise.fareOptions) ? cruise.fareOptions : [];
  const perAdult = perAdultTotal(fare);

  return (
    <article className="cr-card">
      <div className="cr-card__media">
        <img src={placeholder} alt="" loading="lazy" />
        <span className="cr-card__badge">{nightsOf(cruise)} Nights</span>
      </div>

      <div className="cr-card__body">
        <div className="cr-meta">
          {[cruise.cruiseLineName, cruise.shipName].filter(Boolean).join(' · ')}
        </div>
        <div className="cr-card__title">{cruiseTitle(cruise.cruiseName)}</div>
        <div className="cr-card__facts">
          <span>
            <FiCalendar size={14} />
            {formatDateRange(cruise.startDate, cruise.endDate)}
          </span>
          <span>
            <FiAnchor size={14} />
            {titleCase(cruise.startPortName)}
            {' · '}
            {isRoundTrip(cruise)
              ? 'Round trip'
              : `to ${portLabel(titleCase(cruise.endPortName))}`}
          </span>
        </div>
        {options.length > 0 && (
          <div className="cr-fare-tabs">
            {options.map((opt) => {
              const on = opt.fareType === fare?.fareType;
              return (
                <button
                  type="button"
                  key={opt.fareType}
                  className={`cr-fare-tab ${on ? 'is-selected' : ''}`}
                  onClick={() => onFareChange(opt.fareType)}
                  aria-pressed={on}
                >
                  <span className="cr-fare-tab__label">
                    {fareTypeLabel(opt.fareType)}
                  </span>
                  <span className="cr-fare-tab__price">
                    {formatAmount(wholePartyTotal(opt))}
                  </span>
                  {fareTypeSub(opt.fareType) && (
                    <span className="cr-fare-tab__sub">
                      {fareTypeSub(opt.fareType)}
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        )}
      </div>

      <div className="cr-card__price">
        <span className="cr-muted-sm">Total for whole party</span>
        <span className="cr-card__amount">
          {formatAmount(wholePartyTotal(fare))}
        </span>
        {perAdult > 0 && (
          <span className="cr-muted-sm">
            {formatAmount(perAdult)} / adult · incl. taxes
          </span>
        )}
        <AppButton
          btnText="View Cabins"
          size="small"
          className="cr-card__cta"
          onClick={onSelect}
          disabled={!fare}
          style={{ height: '42px', borderRadius: '10px', fontWeight: 600 }}
        />
      </div>
    </article>
  );
}

CruiseCard.propTypes = {
  cruise: PropTypes.object.isRequired,
  fare: PropTypes.object,
  onFareChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

CruiseCard.defaultProps = {
  fare: null,
};

export default CruiseCard;
